var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("ad__" + _vm.type),attrs:{"id":_vm.containerId}},[_vm._t("adContent")],2)}
var staticRenderFns = []

export { render, staticRenderFns }